module.exports = __webpack_public_path__ + "img/balon_no.2012328b.png";